<span nz-icon>
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m17 13.41-4.29-4.24a1.001 1.001 0 0 0-1.42 0l-4.24 4.24a1 1 0 1 0 1.41 1.42L12 11.29l3.54 3.54a1 1 0 0 0 1.41 0 .999.999 0 0 0 .05-1.42Z"
      fill="currentColor"
    />
  </svg>
</span>
